import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import DirectiveHelpSection from "./DirectiveHelpSection.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MarkdownHelp',
    props: {
        mode: null
    },
    setup(__props) {
        const props = __props;
        const page = computed(() => props.mode == "page");
        return { __sfc: true, props, page, DirectiveHelpSection };
    }
});
